import { AxiosResponse } from 'axios';

import { loginApi, loginApiNoIntercept } from '../../setup/setupApi';
import { OauthConnectResponse } from '../oauth2/types';
import {
  BabkaOauthSettingsCreateRequest,
  BabkaOauthSettingsResponse,
  BabkaOauthSettingsUpdateRequest
} from './types';

export const getBabkaLoginOAuthSettings = (
  publisherId: string,
  publisherProjectId?: string
): Promise<BabkaOauthSettingsResponse> => {
  return loginApiNoIntercept
    .get('/oauth2/xsolla/clients', {
      params: { publisher_id: publisherId, publisher_project_id: publisherProjectId }
    })
    .then((res) => res.data);
};

export const connectBabkaLoginOAuthAuth = (
  values: BabkaOauthSettingsCreateRequest
): Promise<OauthConnectResponse> => {
  const { Authorization } = loginApi?.defaults?.headers?.common as unknown as {
    Authorization: string;
  };

  return loginApi
    .post<BabkaOauthSettingsCreateRequest, AxiosResponse<OauthConnectResponse>>(
      `/oauth2/xsolla/clients`,
      values,
      {
        headers: { Authorization }
      }
    )
    .then((res) => res.data);
};

export const updateBabkaLoginOAuthAuth = (
  id: number,
  values: BabkaOauthSettingsUpdateRequest
): Promise<OauthConnectResponse> => {
  const { Authorization } = loginApi?.defaults?.headers?.common as unknown as {
    Authorization: string;
  };

  return loginApi
    .patch<BabkaOauthSettingsUpdateRequest, AxiosResponse<OauthConnectResponse>>(
      `/oauth2/xsolla/clients/${id}`,
      values,
      {
        headers: { Authorization }
      }
    )
    .then((res) => res.data);
};
